export interface RuptureContent {
  label: string;
  /** Titre en deux temps : la ligne de rupture, puis l'affirmation. */
  titleLead: string;
  titleStrong: string;
  titleEmphasis: string;
  paragraphs: readonly string[];
  chipBefore: string;
  chipAfter: string;
  chipResult: string;
}

export const RUPTURE: RuptureContent = {
  label:         'Ce qui me rend différent',
  titleLead:     'Je ne développe pas des logiciels.',
  titleStrong:   'Je conçois des ',
  titleEmphasis: 'systèmes de travail',
  paragraphs: [
    "14 ans à inspecter des pièces de barrages hydroélectriques — complexes, précises, jusqu'à plusieurs tonnes —, à implanter, maintenir et améliorer des systèmes qualité — ISO 9001, GMAO, applications dédiées — et à livrer des dossiers qualité à Hydro-Québec, GE, Voith et Andritz. Tout ce que je conçois aujourd'hui a été pensé grâce à ces années sur le plancher d'usine.",
    "Quand la technologie est nécessaire, je la crée. Quand le processus est le problème, je le repense. L'objectif est toujours le même : éliminer les pertes, augmenter la fiabilité et laisser l'organisation plus efficace qu'à mon arrivée. Asterion Solutions est né de là.",
  ],
  chipBefore: 'Expertise Terrain',
  chipAfter:  'Méthode & Outils',
  chipResult: 'Résultats Mesurables',
};
